import React, { useState } from "react";
import { PaziaButton } from "components/atoms";
import { PaziaModal } from "components/molecules";
import { REGISTRATION_TRANCHE_PAYMENT_STATUSES } from "consts";
import { ModalHeader } from "components/templates/Modals/ModalHeader";
import Papa from "papaparse";
import { InviteUserData } from "../CourseInviteUsersPage";
import { ModalPadding } from "components/templates/Modals/ModalPadding";
import { on } from "events";

interface InviteUsersFromCsvModalProps {
  onCloseRequest: () => void;
  isOpen: boolean;
  onSubmit: (users: InviteUserData[]) => Promise<void>;
}

export const InviteUsersFromCsvModal = ({ onCloseRequest, isOpen, onSubmit }: InviteUsersFromCsvModalProps) => {
  const [file, setFile] = useState<File | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setFile(event.target.files[0]);
      setError(null);
    }
  };

  const closeModal = () => {
    setError(null);
    setFile(null);
    onCloseRequest();
  };
  const handleImport = () => {
    if (!file) {
      setError("Wybierz plik CSV przed zaimportowaniem.");
      return;
    }

    Papa.parse<InviteUserData>(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (result) => {
        if (result.errors.length > 0) {
          setError("Wystąpił błąd podczas przetwarzania pliku CSV.");
          console.error(result.errors);
          return;
        }

        const users = result.data.map((row, idx) => {
          const bornDateTime = row.bornDateTime ? new Date(row.bornDateTime) : undefined;
          bornDateTime?.setHours(12);
          return {
            idx: idx + 1,
            email: row.email || "",
            firstName: row.firstName || "",
            surname: row.surname || "",
            address: row.address || undefined,
            bornPlace: row.bornPlace || undefined,
            bornDateTime: bornDateTime,
            pesel: row.pesel || undefined,
            buyer: row.buyer || undefined,
            phone: row.phone || undefined,
            buyerAddress: row.buyerAddress || undefined,
            buyerNIP: row.buyerNIP || undefined,
            advancePayment: row.advancePayment ? row.advancePayment / 100 : undefined,
            advancePaymentStatus: row.advancePaymentStatus
              ? row.advancePaymentStatus == 100
                ? REGISTRATION_TRANCHE_PAYMENT_STATUSES.PAYED_OUTSIDE_SYSTEM
                : REGISTRATION_TRANCHE_PAYMENT_STATUSES.NOT_PAID
              : undefined,
            restPayment: row.restPayment ? row.restPayment / 100 : undefined,
            restPaymentStatus: row.restPaymentStatus
              ? row.restPaymentStatus == 100
                ? REGISTRATION_TRANCHE_PAYMENT_STATUSES.PAYED_OUTSIDE_SYSTEM
                : REGISTRATION_TRANCHE_PAYMENT_STATUSES.NOT_PAID
              : undefined,
          };
        });

        await onSubmit(users);
        closeModal();
      },
      error: (error) => {
        setError(`Wystąpił błąd: ${error.message}`);
        console.error(error);
      },
    });
  };

  return (
    <PaziaModal id="import-formgroup-modal" onCloseRequest={closeModal} isOpen={isOpen} size="xl">
      <ModalPadding>
        <ModalHeader>Importuj plik CSV</ModalHeader>
        <input type="file" accept=".csv" onChange={handleFileChange} />
        {error && <p className="mt-2 text-red-500">{error}</p>}

        <div className="mt-4 flex justify-end gap-2">
          <PaziaButton type="secondary" onClick={closeModal}>
            Anuluj
          </PaziaButton>
          <PaziaButton type="primary" onClick={handleImport}>
            Zaimportuj
          </PaziaButton>
        </div>
      </ModalPadding>
    </PaziaModal>
  );
};
